<template>
  <div class="py-4 container-fluid">

    <div class="col-12 pb-0  mb-2">
        <div class="card shadow-lg  card-profile-top">
          <div class="card shadow-lg">
            <div class="card-body p-3">
                              <div class="col-auto my-auto">
                    <div class="h-100"><h5 class="mb-1">Integrar Pedidos</h5><p class="mb-0 font-weight-bold text-sm">Pedidos a serem mapeados</p>
                  </div>
                </div>
              <div class="row gx-2">

                <div class="col-auto">
                  <div class="tags-container-operacao">
                        <span 
                          v-for="(tag, index) in data_sincroniza.operacoes" 
                          :key="index" 
                          class="tag"
                        >
                          {{ tag }}
                          <button @click="removeTag(data_sincroniza, tag)" class="remove-btn">&times;</button>
                        </span>
                        <input
                          type="numeric"
                          v-model="data_sincroniza.textTag"
                          @keydown.enter.prevent="addTag(data_sincroniza)"
                          placeholder="Digite a operação"
                          class="tag-input"
                        />
                        <span class="tag-erro" v-if="data_sincroniza.error_operacao"> {{ data_sincroniza.error_operacao  }}</span>
                        
                        <span class="tag-erro" v-if=" data_sincroniza.error"> {{ data_sincroniza.error  }}</span>
                        <span class="tag-erro" v-if=" data_sincroniza.loading"> 
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                  </div>
                </div>
                <div class="col-auto">
                  <div class="tags-container-operacao">
                        <span 
                          v-for="(tag, index) in data_sincroniza.pedidos" 
                          :key="index" 
                          class="tag"
                        >
                          {{ tag }}
                          <button @click="removePedido(data_sincroniza, tag)" class="remove-btn">&times;</button>
                        </span>
                        <input
                          type="numeric"
                          v-model="data_sincroniza.textPedido"
                          @keydown.enter.prevent="addPedido(data_sincroniza)"
                          placeholder="Digite número do Pedido"
                          class="pedidos-input"
                        />
                        <span class="tag-erro" v-if="data_sincroniza.error_operacao"> {{ data_sincroniza.error_operacao  }}</span>
                        
                        <span class="tag-erro" v-if=" data_sincroniza.error"> {{ data_sincroniza.error  }}</span>
                        <span class="tag-erro" v-if=" data_sincroniza.loading"> 
                          <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </span>
                  </div>
                </div>
                <div class="col-auto">
                           
                            <Multiselect
                             style="width: 600px;"
                              v-model="data_sincroniza.janelas"
                              placeholder="Janelas"
                              mode="tags"
                              :close-on-select="false"
                              :searchable="true"
                              :create-option="true"
                                noOptionsText="Nenhuma opção disponível"
                                noResultsText="Nenhum resultado encontrado"
                                multipleLabel="Itens selecionados"
                                optionsLabel="Opções disponíveis"
                                selectLabel="Pressione Enter para selecionar"
                                deselectLabel="Pressione Enter para remover"
                                selectedLabel="Selecionado"
                              :options="[
                                  { value: '1', label: '08:00-10:00' },
                                  { value: '2', label: '10:00-12:00' },
                                  { value: '3', label: '12:00-14:00' },
                                  { value: '4', label: '14:00-16:00' },
                                  { value: '5', label: '16:00-18:00' },
                                  { value: '6', label: '18:00-20:00' },
                              ]"
                            />
              </div> 
               <div class="col-auto p-3">

                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="data_sincroniza.reimportar">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Ignorar Concluídos</label>
                      </div>
                                        
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="data_sincroniza.sobrescrever">
                        <label class="form-check-label" for="flexSwitchCheckDefault">Acumular Pedidos</label>
                      </div>

              </div>
              <div class="col-auto p-3 mt-2">
                      <label for="start-date">Data inicial:</label>
                      <input type="date" v-model="data_sincroniza.data_inicial" id="start-date" name="start-date">
                    
           

                      <label for="end-date">Data final:</label>
                      <input type="date" v-model="data_sincroniza.data_final" id="end-date" name="end-date">

              </div>
               
              <div class="mx-auto mt-3 col-lg-12 col-md-12 col-sm-12  my-sm-auto ms-sm-auto me-sm-0">
                <div class="nav-wrapper position-relative">
                  <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">

                    <li class="nav-item my-auto">

                      

                        <argon-button
                            @click="doSync()"
                            variant="gradient"
                            color="success"
                            fullWidth
                            :disabled="sincronizar.show"
                            size="lg">
                            Sincronizar
                        </argon-button>

                    </li>
                  </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="sincronizar.show">
          <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.show">

            <div class="d-flex flex-column d-flex align-items-center ">
              
                
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
            </div>

            <div class="progress-wrapper">
                <div class="progress-info">
                  <div class="progress-percentage">
                    <span class="text-sm font-weight-bold">{{sincronizar.progress}}%</span>
                  </div>
                </div>
                <div class="progress">
                 <div
                    class="progress-bar bg-primary"
                    role="progressbar"
                    :aria-valuenow="sincronizar.progress"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    :style="{ width: sincronizar.progress + '%' }"
                  ></div>
                </div>
            </div>
            
          </div>

          <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.success && !sincronizar.show">

            <div class="alert alert-success d-flex align-items-center" role="alert">
              <i class="fas fa-check-circle text-success me-2"></i>
              <span>Operação realizada com sucesso!</span>
            </div>

          </div>


        </div>
      </div>

   
    <div class="row">
      <div class="col-12">
        <pedidos-table  :pedidos="pedidos" :doUpdate="doUpdate" :doAddTag="doAddTag" :doRemoveTag="doRemoveTag"  :doRemovePedido="doRemovePedido" :searchCall="searchCall" />
        <loading  v-if="isLoading" />

          <div class="dataTable-bottom">
            <div class="dataTable-info">
              Mostrando {{ current_page * per_page + 1 }} até 
              <select v-model.number="per_page" @change="getPaginas(0)">
                <option v-for="option in per_page_options" :key="option" :value="option">
                  {{ option === -1 ? 'Todos' : option }}
                </option>
              </select> de 
              {{ total_count }} {{ local_page }}
            </div>



            <nav class="dataTable-pagination">
              <ul class="dataTable-pagination-list">
                <li @click="getPaginas(Math.max((current_page - 1) * per_page, 0))" 
                    class="pager" 
                    :class="{ disabled: current_page === 0 }">
                  <a href="#">‹</a>
                </li>

                <li v-for="page in total_pages" :key="page" 
                    @click="getPaginas((page - 1) * per_page)" 
                    :class="{ active: current_page === (page - 1) }">
                  <a href="#">{{ page }}</a>
                </li>

                <li @click="getPaginas(Math.min((current_page + 1) * per_page, (total_pages - 1) * per_page))" 
                    class="pager"
                    :class="{ disabled: current_page === total_pages - 1 }">
                  <a href="#">›</a>
                </li>
              </ul>
            </nav>
          </div>

      </div>
    </div>
  </div>
</template>
<style>
.multiselect {
  --ms-border-radius: .5rem;
  --ms-border-color: #ced4da;
  --ms-bg: #fff;
  --ms-ring-color: #5e72e4;
}
</style>

<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { defineComponent, ref } from 'vue';


import PedidosTable from "./components/PedidosTable.vue";
import ProjectsTable from "./components/ProjectsTable.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Multiselect from '@vueform/multiselect'

import '@vueform/multiselect/themes/default.css'


import Loading from "./components/Loading.vue";

import fintailapi from "../api";

const { v4: uuidv4 } = require('uuid');

import { useToast } from "vue-toastification";

 
export default defineComponent({
  name: "tables",
  components: {
    PedidosTable,
    ProjectsTable,
    ArgonButton,
    Loading,
    Multiselect
  },
  data() {
    return {
      map: null,
      google: null,
      data_sincroniza: {reimportar : true, sobrescrever : true, data_inicial:"", data_final:"", operacoes:[], janelas: [  "1",  "2",  "3",  "4",  "5",  "6" ]},
      sincronizar: { show:false, progress:0 },
      listaJanelas: [
      { id: 1, nome: "Entrega" },
      { id: 2, nome: "Retirada" },
      { id: 3, nome: "Troca" },
      { id: 4, nome: "Reentrega" },
    ],
      modo : "view",
      pedidos: [],
      current_page:0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
      isLoading:true,
      showMapa:true,
      per_page: 10,
      per_page_options: [10, 30, 50, 100, -1], // -1 = todos
      toast : useToast(),
      local_page : "Pedidos",
    };
  },
  async mounted() {
    
    this.getPedidos(0)
    

  },
  methods: {
    doUpdate(event, pedido) {

        this.sincronizar.show = true
        this.sincronizar.progress = 25

        fintailapi
        .put(`/pedidos/${pedido.id_pedido}`,  pedido)
        .then((response) => {
            this.sincronizar.progress = 100
            this.sincronizar.show = false
            this.getPedidos(0)
        })
        .catch((error) => {
          this.sincronizar.show = false
          this.sincronizar.error = error.message
        })

    },
    doAddTag(pedido, codigo_embalagem) {

        pedido.codigo_embalagem = codigo_embalagem
        pedido.error = null
        pedido.loading = true

        fintailapi
        .post(`/pedidos/embalagem/${pedido.id_pedido}`,  pedido)
        .then((response) => {
          
            //this.sincronizar.progress = 100
            //this.sincronizar.show = false
            pedido.loading = false

            pedido.id_embalagem = response.data.id_embalagem

            pedido.embalagens.push({ id_embalagem : response.data.id_embalagem, codigo_embalagem: codigo_embalagem.trim()});
          
            
        })
        .catch((error) => {
          
          pedido.error = "Unidade de Transporte "+codigo_embalagem+" não cadastrada."
          pedido.embalagens.pop();
          pedido.loading = false

          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
          
        })


    },
    doRemoveTag(pedido, id_embalagem) {

      this.sincronizar.show = true
      this.sincronizar.progress = 20


      fintailapi
      .delete(`/pedidos/embalagem/${pedido.id_pedido}/${id_embalagem}`)
      .then((response) => {

          this.sincronizar.progress = 100
          this.sincronizar.show = false

          this.getPedidos(0)

      })
      .catch((error) => {
        this.sincronizar.show = false
        this.sincronizar.error = error.message
      })

    },
    doCheckSync() {
      fintailapi
        .get(`/pedidos/check/${this.data_sincroniza.uuid}`)
        .then((response) => {
          this.sincronizar.progress = response.data.progresso;
          
          console.log(response.data.status)
          
          if (response.data && response.data.status === 'completo') {
            this.sincronizar.success = true;
            this.sincronizar.show = false;
            this.getPedidos(0)
          }else if (response.data && response.data.status === 'falha') {
            
            this.sincronizar.success = true;
            this.sincronizar.show = false;
            this.sincronizar.show = false;
            this.sincronizar.error = response.data.mensagem
            this.data_sincroniza.error = response.data.mensagem
          
          } else {
            setTimeout(() => {
              this.doCheckSync();
            }, 5000); // Verifica novamente após 5 segundos
          }
        })
        .catch((error) => {
          this.sincronizar.show = false;
          this.sincronizar.error = error.message;
        });
    },
    doSync(offset) {
      this.sincronizar.show = true;
      this.sincronizar.progress = 0;

      this.data_sincroniza.uuid = uuidv4();

      fintailapi
        .post('/pedidos/sincronizar', this.data_sincroniza)
        .then(() => {
          this.sincronizar.progress = 10;
          this.doCheckSync();
        })
        .catch((error) => {
           this.toast.error(`${ error.response.data.message }, tente novamente.`);
          this.sincronizar.show = false;
          this.sincronizar.error = error.message;
        });
    },
    removeTag(pedido, tag) {
       console.log(tag)
      if (!pedido.operacoes) pedido.operacoes = [];
      pedido.operacoes = pedido.operacoes.filter(t => t !== tag);

    },
    addTag(pedido) {
        this.data_sincroniza.error_operacao=null;
        fintailapi
        .get(`/operacoes/${pedido.textTag}`)
        .then((response) => {

            if(!pedido.operacoes)pedido.operacoes = [];
            if (pedido.textTag.trim() !== "" && !pedido.operacoes.includes(pedido.textTag)) {
              pedido.operacoes.push( pedido.textTag.trim() );
              pedido.textTag = "";
            }
        
        })
        .catch((error) => {
            this.data_sincroniza.error_operacao=`Operação ${pedido.textTag} não Localizada`;
        })


    },
    removePedido(pedido, tag) {
      if (!pedido.pedidos) pedido.pedidos = [];
      pedido.pedidos = pedido.pedidos.filter(t => t !== tag);

    },
    addPedido(pedido) {
        this.data_sincroniza.error_operacao=null;

        if(!pedido.pedidos)pedido.pedidos = [];
        if (pedido.textPedido.trim() !== "" && !pedido.pedidos.includes(pedido.textPedido)) {
          pedido.pedidos.push( pedido.textPedido.trim() );
          pedido.textPedido = "";
        }
        


    },

    doRemovePedido(pedido) {

        fintailapi
        .delete(`/pedidos/${pedido.id_pedido}`)
        .then((response) => {

            this.sincronizar.progress = 100
            this.sincronizar.show = false

            this.getPedidos(0)

        })
        .catch((error) => {
          this.sincronizar.show = false
          this.sincronizar.error = error.message
        })


    },
    getPaginas(offset) {

        if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos
        
        this.current_offset = offset;

        this.getPedidos(offset);       

    },
    getPedidos(offset) {

        this.isLoading = true
        
        fintailapi
        .get(`/pedidos?offset=${offset}&limit=${ this.per_page}`)
        .then((response) => {

          this.isLoading=false
 
          this.pedidos = response.data.pedidos;

          this.current_page = offset /  this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count /  this.per_page);

        })
        .catch((error) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
    searchCall(campo, termo) {

      fintailapi
        .get(`/pedidos/pesquisar/campo?term=${termo}&field=${campo}`)
        .then((response) => {
          this.current_offset = 0;
          this.current_page = 0 / this.per_page; // Atualiza a página com base no offset
          this.total_count = response.data.count;
          this.total_pages = Math.ceil(response.data.count / this.per_page);
          this.pedidos = response.data.rows;
        })
        .catch((error) => {
          this.toast.error(`Erro:${ error.response.data.error }, tente novamente.`);
        })

    },
  },
  created() {

      this.modo = this.$route.params.id||'view';

  },

});


</script>
